/**
 * Token counts as a footer reads them — a glance, not a ledger: 157, 3.5k, 1.2m.
 *
 * A sibling module because two components format counts, and a component file exports
 * components only.
 */
export const compactCount = (count: number): string => {
    if (count === 0) {
        return '0';
    }

    if (count >= 1_000_000) {
        return `${(count / 1_000_000).toFixed(1)}m`;
    }

    if (count >= 1_000) {
        return `${(count / 1_000).toFixed(1)}k`;
    }

    return count.toLocaleString();
};

/** An absent count reads as a dash rather than as zero, which would claim it was measured. */
export const compactOrDash = (count: number | null | undefined): string =>
    count === null || count === undefined ? '-' : compactCount(count);
